import type {Country} from '@apispec/validator';
import {CountriesService} from '@plugins/countries/CountriesService';
import {getCurrentLocale} from '@plugins/i18n/i18n';
import {Countries} from '@plugins/injections';
import {type App, inject, type Ref} from 'vue';

export function useCountryService(): CountriesService {
  const countries = inject(Countries);
  if (!countries) {
    throw new Error('Countries not available, did you enable the countries plugin?');
  }

  return countries;
}

export function useCountries(): Ref<Country[]> {
  return useCountryService().getCountries();
}

export default function(app: App): void {
  app.runWithContext(() => {
    app.provide(Countries, new CountriesService(
      getCurrentLocale(),
    ));
  });
}
